'use strict';
module.exports = require('./Chip.vue');